// Native
import { Button, Separator, Text } from "@chakra-ui/react"
import { useNavigate } from "react-router"

// Custom
import { UI } from "components"
import useUser from "hooks/useUser"

export default function PointsBonus(props){

    const navigate = useNavigate()
    const user = useUser()
    const consultant = user.data?.consultant

    return(
    <UI.Box loading={user.isLoading} {...props}>
        <Text children="Pontos qualificáveis:" color="GrayText" />
        <Text children={<UI.Number.Number value={consultant?.qualified_points_balance} />} fontSize="3xl" fontWeight="bold" />
        <Button size="xs" variant="ghost" children="Visualizar pontuação" onClick={() => navigate('/pontos')} />
        <Separator my={4} />
        <Text children="Bônus disponível:" color="GrayText" />
        <Text children={<UI.Number.Amount value={consultant?.bonus_balance} />} fontSize="2xl" fontWeight="bold" color="green" />
        <Button size="xs" variant="ghost" children="Ver bonificação" onClick={() => navigate('/bonus')} />
    </UI.Box>
    )
}